import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/UserContext';
import { useGroupsFilter } from '../../context/GroupsFilterContext';
import ConstellationLayout from '../../components/ConstellationLayout';

const HomePage = () => {
    const { t } = useTranslation();
    const navigate = useHistory();
    const { logOff } = useContext(UserContext);
    const { groups, error, selectedYear } = useGroupsFilter();

    const errorMessage = error
        ? error.startsWith('error_status:')
            ? t('home.error_status', { status: error.split(':')[1] })
            : t('home.error_connection')
        : null;

    return (
        <ConstellationLayout>
            <div style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                {errorMessage && (
                    <div className="alert alert-danger" style={{ maxWidth: '800px', width: '100%' }}>
                        {errorMessage}
                    </div>
                )}
                {selectedYear !== null && (
                    <h4 className="custom-font" style={{ maxWidth: '800px', width: '100%', color: '#0d6efd', marginBottom: '1rem' }}>
                        {t('home.year_title', { year: selectedYear })}
                    </h4>
                )}
                <table className="table" style={{ maxWidth: '800px', width: '100%' }}>
                    <thead>
                        <tr>
                            <th className="custom-font" style={{ color: '#a1a4a5' }}>{t('home.group_column')}</th>
                            <th className="custom-font" style={{ color: '#a1a4a5', textAlign: 'center' }}>{t('home.milestones_column')}</th>
                            <th className="custom-font" style={{ color: '#a1a4a5', textAlign: 'center' }}>{t('home.report_column')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groups?.map((el: any) => (
                            <tr key={el.id}>
                                <td className="custom-font" style={{ color: '#a1a4a5', verticalAlign: 'middle' }}>
                                    {el.name}
                                </td>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <span
                                        className="custom-font"
                                        onClick={() => navigate.push(`/group?id=${el.id}&name=${el.name}`)}
                                        style={{
                                            color: '#a1a4a5',
                                            cursor: 'pointer',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={e => (e.currentTarget.style.textDecoration = 'underline')}
                                        onMouseLeave={e => (e.currentTarget.style.textDecoration = 'none')}
                                    >
                                        {t('home.view_link')}
                                    </span>
                                </td>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <span
                                        className="custom-font"
                                        onClick={() => navigate.push(`/reporte-grupo?group_id=${el.id}&name=${el.name}`)}
                                        style={{
                                            color: '#a1a4a5',
                                            cursor: 'pointer',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={e => (e.currentTarget.style.textDecoration = 'underline')}
                                        onMouseLeave={e => (e.currentTarget.style.textDecoration = 'none')}
                                    >
                                        {t('home.view_link')}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button
                    className={`btn btn-outline-success button`}
                    style={{ marginTop: '1rem' }}
                    onClick={() => logOff()}>{t('home.log_off')}
                </button>
            </div>
        </ConstellationLayout>
    )
}

export default HomePage
